export default __webpack_public_path__ + "static/media/referralBanner.d64b68e6.png";